
import React from 'react';
import { useTranslation } from 'react-i18next';
import { clientLogos } from '../constants.tsx';

const Clients: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="py-16">
            <div className="max-w-6xl mx-auto px-4 sm:px-8 xl:px-0">
                <div
                    className="w-full flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]"
                >
                    <ul className="flex items-center justify-start flex-shrink-0 [&_li]:mx-8 [&_img]:h-28 [&_img]:w-auto animate-infinite-scroll">
                        {clientLogos.map((logo, index) => (
                            <li key={index}>{React.cloneElement(logo, { alt: t('clientLogoAlt', { number: index + 1 }) })}</li>
                        ))}
                    </ul>
                    <ul className="flex items-center justify-start flex-shrink-0 [&_li]:mx-8 [&_img]:h-28 [&_img]:w-auto animate-infinite-scroll" aria-hidden="true">
                        {clientLogos.map((logo, index) => (
                            <li key={index}>{React.cloneElement(logo, { alt: t('clientLogoAlt', { number: index + 1 }) })}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Clients;